
























import { Component, Prop, Emit, Watch, Ref, Mixins } from 'vue-property-decorator';
import SInputBase from '@/components/UI/Form/SInputBase.vue';
import SFormElement from './SFormElement.vue';

@Component({
  components: {
    SInputBase,
  },
})
export default class SAmountInput extends Mixins(SFormElement) {
  @Prop(Number) public value!: number | null;
  @Ref() public readonly inputRef!: SInputBase;

  private internalValue = this.toFormatted(this.value);

  get listeners() {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { input, ...listeners } = this.$listeners;
    return listeners;
  }

  public focus() {
    this.inputRef.focus();
  }

  public select() {
    this.inputRef.select();
  }

  public blur() {
    this.inputRef.blur();
  }

  public selectAllButFirst() {
    this.inputRef.selectAllButFirst();
  }

  @Watch('$i18n.locale')
  public formatValue() {
    this.internalValue = this.toFormatted(this.value);
  }

  @Watch('value')
  private updateInternalValue() {
    if (this.value === this.toNumber(this.internalValue)) return;
    this.internalValue = this.toFormatted(this.value);
  }

  @Watch('internalValue')
  @Emit('input')
  private updateValue() {
    return this.toNumber(this.internalValue);
  }

  private toNumber(value: string): number | null {
    if (value === ``) return null;
    else return parseInt(value);
  }

  private toFormatted(value: number | null): string {
    if (value === 0) return "0";
    else if (!value) return "";
    return value.toString();
  }
}
